import { render, staticRenderFns } from "./AMCPlanDetails.vue?vue&type=template&id=3b7a39c4&scoped=true"
import script from "./AMCPlanDetails.vue?vue&type=script&lang=js"
export * from "./AMCPlanDetails.vue?vue&type=script&lang=js"
import style0 from "./AMCPlanDetails.vue?vue&type=style&index=0&id=3b7a39c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a39c4",
  null
  
)

export default component.exports